/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetCategoryQuery } from '../../models/get-category-query';
import { GetCategoryResult } from '../../models/get-category-result';

export interface ApiNurseryManagerCategoryGetCategoryPost$Plain$Params {
      body?: GetCategoryQuery
}

export function apiNurseryManagerCategoryGetCategoryPost$Plain(http: HttpClient, rootUrl: string, params?: ApiNurseryManagerCategoryGetCategoryPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<GetCategoryResult>> {
  const rb = new RequestBuilder(rootUrl, apiNurseryManagerCategoryGetCategoryPost$Plain.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetCategoryResult>;
    })
  );
}

apiNurseryManagerCategoryGetCategoryPost$Plain.PATH = '/api/NurseryManager/Category/GetCategory';
